<template>
    <div class="cz2__ai-modal__selfie-say-cheese">
        <div class="hide--below-lg cz2__modal-popup__header">
            {{ $t('AI_SELFIE_CHEESE_HEADING') }}
        </div>

        <selfie-stream />
    </div>
</template>

<style lang="scss">
    @import "../../style/variables.scss";

    #cz2.cz2 {
        .cz2__ai-modal {
            .cz2__ai-modal__selfie-say-cheese {
                width: 100%;
                height: 100%;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                gap: 24px;
                background-color: #fff;
            }
        }
    }
</style>

<script>
    import Btn from '../ui/Btn.vue';
    import LoadingSpinner from '../ui/LoadingSpinner.vue';
    import SelfieStream from './SelfieStream.vue';

    export default {
        components: {
            Btn,
            LoadingSpinner,
            SelfieStream,
        },

        data() {
            return {
                isLoading: false,
            };
        },

        computed: {
            aiSelfieStates() {
                return this.$store.state.aiSelfieStates;
            },
        },

        methods: {
            takeSelfie() {
                this.isLoading = true;

                setTimeout(() => {
                    this.isLoading = false;

                    this.$store.dispatch('setAiSelfieActiveState', this.aiSelfieStates.loading);

                    setTimeout(() => {
                        this.$store.dispatch('setAiSelfieActiveState', this.aiSelfieStates.building);
                        this.$store.dispatch('buildFromSelfie');
                    }, 2000);
                }, 2000);
            },
        },
    };
</script>
